import { defineStore } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';

export const useApp = defineStore('rapidDiffsApp', {
  state() {
    return {
      appVisible: true,
    };
  },
});
